import React from 'react';
import notFoundImage from './../../assets/images/notFound.png'
import MDButton from "../../components/MDButton";
import {useNavigate} from "react-router-dom";

const NotFoundPage = () => {
    const nav = useNavigate()
    return (
        <React.Fragment>
            <div style={{width:'100vw',height:'100vh',display:'flex',flexDirection:'column',alignItems:'center'}}>
                {/*<h1>404 - Page Not Found</h1>*/}
                <img src={notFoundImage} alt="404 Not Found" style={{width:'40%',maxHeight:'80%'}}/>
                {/*<p style={{marginTop:'-20px'}}>Sorry, the page you are looking for does not exist.</p>*/}
                <MDButton onClick={()=>nav(-1)} color={'primary'} variant={'gradient'}>Go Back</MDButton>
            </div>

        </React.Fragment>
    );
};

export default NotFoundPage;